import { cn, Stack, StackProps, Tooltip, TooltipContent, TooltipTrigger } from '@landler/component-library';
import { FC, HTMLAttributes, ReactNode } from 'react';

import { Icon } from '../../a/Icon/Icon';

export type CardStyles = {
  root?: string;
  header?: string;
  body?: string;
  footer?: string;
};

export type CardProps = HTMLAttributes<HTMLDivElement> & {
  header?: ReactNode;
  headerTooltip?: ReactNode;
  body?: ReactNode;
  footer?: ReactNode;
  styles?: CardStyles;
} & StackProps;

export const Card: FC<CardProps> = ({
  header,
  headerTooltip,
  body,
  footer,
  children,
  styles = {},
  className,
  ...props
}) => {
  return (
    <Stack className={cn('rounded-lg border border-neutral-black-12 bg-white-100', styles.root, className)} {...props}>
      {header && (
        <div className={cn('px-6 py-4 border-b border-neutral-black-12', styles.header)}>
          <span>{header}</span>
          {headerTooltip && (
            <Tooltip>
              <TooltipTrigger className='items-center'>
                <Icon icon='ri-information-line' className='ml-1 text-active-54 typography-body1' />
              </TooltipTrigger>
              <TooltipContent>{headerTooltip}</TooltipContent>
            </Tooltip>
          )}
        </div>
      )}
      <div className={cn('px-6 py-4 whitespace-pre-wrap', styles.body)}>{body || children}</div>
      {footer && <div className={cn('px-6 py-4 border-t border-neutral-black-12', styles.footer)}>{footer}</div>}
    </Stack>
  );
};
